import React from "react";
import {AiNewGamesListComponent} from "../../../../../components/ai-new-games-list/ai-new-games-list.component";
import {SwiperListBaseModel} from "../swiper-list-base.model";
import {SwiperGamesListConfiguration} from "../../../../configurations/config-data-sections/arenas.configuration";
import {IArenaToGamesListAdapter} from "../../arenas/arena-to-games-list-adapter.interface";
import {Check} from "@sparkware/app-utils";

export class NewGamesListModel extends SwiperListBaseModel {
    constructor(protected readonly listConfiguration: SwiperGamesListConfiguration,
                arena: IArenaToGamesListAdapter) {
        super(listConfiguration, arena);
    }

    protected _shouldBeDisplayed(): boolean {
        if(Check.isNullOrUndefined(this.services.aiNewEngine.aiNewRecommendedGames)) {
            return super._shouldBeDisplayed();
        }

        return super._shouldBeDisplayed() && this.gameTypes.length > 0;
    }

    protected _getGameTypes(): number[] {
        return this.services.aiNewEngine.aiNewRecommendedGames?.gameTypes || [];
    }

    protected _getTitleTranslationParams() {
        return this.services.user.name;
    }

    get aiEngine(): string {
        return this.services.aiNewEngine.aiNewRecommendedGames?.engine || '';
    }

    _renderList(listPosition: number): React.ReactElement | null {
        return <AiNewGamesListComponent key={this.listKey} viewModel={this} listPosition={listPosition}/>;
    }
}